import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
const IconList = ({ list })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "ptw-flex ptw-flex-col ptw-p-4",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("ul", {
            className: "ptw-mt-0 ptw-pl-0 ptw-leading-6",
            children: list.map((item)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("li", {
                    className: "ptw-mb-4 ptw-grid ptw-grid-cols-[1fr_5fr]",
                    children: [
                        'string' == typeof item.icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("img", {
                            src: item.icon,
                            alt: ""
                        }) : item.icon,
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                            className: "ptw-ml-3",
                            children: item.description
                        })
                    ]
                }, item.description))
        })
    });
const IconList_IconList = IconList;
export { IconList_IconList as default };
